import {
    ActiveDirectoryDetailsItem,
    ActiveDirectoryMapping,
} from '../components/settings-integrations-active-directory-details';
import { ActiveDirectoryListItem } from '../components/settings-integrations-active-directory-list';
import { MASKED_PASSWORD_PLACEHOLDER } from '../settings-integrations-active-directory.constants';
import {
    ActiveDirectoryDetailsFormState,
    ActiveDirectoryDetailsItemAPI,
    ActiveDirectoryListItemAPI,
    ActiveDirectoryMappingsAPI,
    ConnectionStatus,
    ConnectionStatusCodes,
    CreateOrUpdateActiveDirectoryApiRequest,
    IdentityProviderMapping,
    IdentityProviderMappingAPI,
} from '../types/active-directory.type';

const mapStatusToConnectionStatus = (status: string, active: boolean): ConnectionStatus => {
    if (!active) {
        return ConnectionStatusCodes.DEACTIVATED;
    }

    return (Object.values(ConnectionStatusCodes) as string[]).includes(status)
        ? (status as ConnectionStatus)
        : ConnectionStatusCodes.PENDING;
};

const mapActiveDirectoryMappings = (index: number, mapping: ActiveDirectoryMappingsAPI): ActiveDirectoryMapping => ({
    index,
    identityProviderField: mapping.identityProviderField,
    operatorField: mapping.operatorField,
});

export const mapActiveDirectoryListItemFromApiToVm = (item: ActiveDirectoryListItemAPI): ActiveDirectoryListItem => ({
    id: item.id,
    name: item.name,
    status: mapStatusToConnectionStatus(item.status, item.active),
    lastSync: item.lastSync ? new Date(item.lastSync).toISOString() : undefined,
    existDataMapping: item.existDataMapping,
    hasSavedPassword: item.hasSavedPassword,
    errorConnectionDetail: item.errorConnectionDetail,
    lastAttempt: item.lastAttempt ? new Date(item.lastAttempt).toISOString() : undefined,
});

export const mapActiveDirectoryDetailsItemFromApiToVm = (
    item: ActiveDirectoryDetailsItemAPI
): ActiveDirectoryDetailsItem => ({
    id: item.id,
    name: item.name,
    url: item.url,
    group: item.group,
    interval: item.interval,
    username: item.username,
    userGroup: item.userGroup,
    status: mapStatusToConnectionStatus(item.status, item.active),
    lastSync: item.lastSync ? new Date(item.lastSync).toISOString() : undefined,
    existDataMapping: item.existDataMapping,
    hasSavedPassword: item.hasSavedPassword,
    errorConnectionDetail: item.errorConnectionDetail,
    lastAttempt: item.lastAttempt ? new Date(item.lastAttempt).toISOString() : undefined,
    mappings: item.mappings?.map((mapping, index) => mapActiveDirectoryMappings(index, mapping)) ?? [],
    identityProviderAttributes: item.identityProviderAttributes ?? [],
});

const mapIdentityProviderMappingFromModelToAPI = (mappings: IdentityProviderMapping[]): IdentityProviderMappingAPI[] =>
    mappings.map((m) => ({ identityProviderField: m.identityProviderField, operatorField: m.operatorField }));

export const mapActiveDirectoryDetailsItemFromVmToApi = (
    payload: ActiveDirectoryDetailsFormState,
    identityProviderAttributes: string[]
): CreateOrUpdateActiveDirectoryApiRequest => ({
    name: payload.name,
    url: payload.url,
    group: payload.group,
    interval: payload.interval,
    username: payload.username,
    userGroup: payload.userGroup,
    ...(payload.password && payload.password !== MASKED_PASSWORD_PLACEHOLDER && { password: payload.password }),
    mappings: payload.mappings ? mapIdentityProviderMappingFromModelToAPI(payload.mappings) : [],
    identityProviderAttributes,
});
